/**
 * User: daletan
 * Date: 6/24/14
 * Time: 1:34 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var $ = require('dibs-jquery-shim');

require('global/plugins/dibs-tooltip');

/**
 * @param [event]
 * @param [params]
 */
exports.initTooltips = function (event, params) {
    var triggerSelector = ".dibstooltip-trigger";
    var triggers;
    var unbound;

    params = params || {};

    if (params.context) {
        triggers = params.context.$(triggerSelector);
    } else if (params.el) {
        triggers = $(params.el);
    } else {
        triggers = $(triggerSelector);
    }

    if (triggers.length) {
        unbound = triggers.not(':data(ui-tooltip)');
        if (unbound.length) {
            unbound.dibsTooltip();
        }
    }
};

exports.closeAllTooltips = function () {
    var triggers = $('.dibstooltip-trigger');
    var bound;

    if (triggers.length) {
        bound = triggers.filter(':data(ui-tooltip)');
        if (bound.length) {
            bound.dibsTooltip('close');
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/commonjs/dibsTooltips.js
// module id = 2580
// module chunks = 63